const advancePlanConstants = {
    GET_ADVANCE: "GET_ADVANCE",
    ADD_ADVANCE: "ADD_ADVANCE",
}

export default advancePlanConstants;